
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/purchases",
      function () {
        return require("private-next-pages/my/purchases/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/purchases"])
      });
    }
  